import AltDateWidget from "./AltDateWidget";
import AltDateTimeWidget from "./AltDateTimeWidget";
import BaseInput from "./BaseInput";
import CheckboxWidget from "./CheckboxWidget";
import CheckboxesWidget from "./CheckboxesWidget";
import ColorWidget from "./ColorWidget";

import DateWidget from "./DateWidget";
import DateTimeWidget from "./DateTimeWidget";
import TimeWidget from "./TimeWidget";

import EmailWidget from "./EmailWidget";
import FileWidget from "./FileWidget";
import HiddenWidget from "./HiddenWidget";
import PasswordWidget from "./PasswordWidget";
import RadioWidget from "./RadioWidget";
import RangeWidget from "./RangeWidget";
import SelectWidget from "./SelectWidget";
import TextareaWidget from "./TextareaWidget";
import EditorWidget from "./EditorWidget";

import TextWidget from "./TextWidget";
import URLWidget from "./URLWidget";
import UpDownWidget from "./UpDownWidget";

import ColorpickerWidget from "./ColorpickerWidget";
import SwitchWidget from "./SwitchWidget";
import CodeWidget from "./CodeWidget";

import UuidWidget from "./UuidWidget";
import SettingWidget from "./SettingWidget";

export default {
    BaseInput: BaseInput,
    PasswordWidget: PasswordWidget,
    RadioWidget: RadioWidget,
    UpDownWidget: UpDownWidget,
    RangeWidget: RangeWidget,
    SelectWidget: SelectWidget,
    TextWidget: TextWidget,

    DateWidget: DateWidget,
    DateTimeWidget: DateTimeWidget,
    TimeWidget: TimeWidget,

    AltDateWidget: AltDateWidget,
    AltDateTimeWidget: AltDateTimeWidget,
    EmailWidget: EmailWidget,
    URLWidget: URLWidget,
    TextareaWidget: TextareaWidget,
    HiddenWidget: HiddenWidget,
    ColorWidget: ColorWidget,
    FileWidget: FileWidget,
    CheckboxWidget: CheckboxWidget,
    CheckboxesWidget: CheckboxesWidget,

    "uuid": UuidWidget,

    "grid": SelectWidget,
    "size": SelectWidget,

    "colorpicker": ColorpickerWidget,
    "textarea": TextareaWidget,
    "editor": EditorWidget,
    "switch": SwitchWidget,
    "code": CodeWidget
};